import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./reducers/rootReducer";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import logger from "redux-logger";

const persistConfig = {
  key: "root_v1",
  storage,
  blacklist: ["GlobalLoadingState", "ModalState"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);
// TO-REVIEW: when REHYDRATE happens, store is reset.

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => {
    const defaultMiddleware = getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    });
    return process.env.NODE_ENV !== "production"
      ? defaultMiddleware.concat(logger as any)
      : defaultMiddleware;
  },
});

const persistor = persistStore(store);

export default store;
export { persistor };
